export enum OrderTaskStatuses {
  INVALID_STATUS = "INVALID_STATUS",
  BLOCKED = "BLOCKED",
  TO_DO = "TO_DO",
  IN_PROGRESS = "IN_PROGRESS",
  CANCELED = "CANCELED",
  DONE = "DONE",
  SKIPPED = "SKIPPED",
}
